<template>
  <div id="box" class="content-box">
    <div class="content">
      <a class="rearson" :href="'tel:' + tel" :class="{ 'flash': true }">
        <div class="txt">投诉</div>
        <div class="txt">退款电话</div>
      </a>
      <div class="header-box">
        <div class="sign-box">
          <!-- <img class="logo" src="../../assets/zx/logo.png" alt=""> -->
          <div class="header-title">{{ sign }}企业服务助手</div>
        </div>
        <!-- <div class="tel-box">
          <img class="tel-icon" src="../../assets/zx/tel.png" alt="">
          <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="uc-blue">{{ tel }}</a>
        </div> -->
      </div>
      <div class="info-box">
        <div class="company-box">
          <div class="company">{{ companyName }}</div>
          <div class="tis">有历史年报漏报记录，需完成补报！</div>
          <div class="legalPerson-box" v-if="legalPerson"><span>经营者</span><span class="legalPerson">{{ legalPerson
          }}</span></div>
        </div>
        <div class="lxfs-box">
          <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="tel-btn"
            :class="{ 'flash': true }">电话咨询办理</a>
          <a :href="WeChatCS" @click="handleWx" rel="external nofollow" class="wx-btn"
            :class="{ 'flash': true }">微信咨询办理</a>
        </div>
        <div class="tips2"><span class="red">*</span>以上信息均来自于国家企业信用信息公司系统</div>
      </div>
      <div class="fk-list-box">
        <div class="title">未申报年报将受到最高10000元罚款</div>
        <div class="fk-title">相关法律法规规定</div>
        <div class="fk-list">
          当年12月31日前登记注册的企业、个体工商户，应当于次年6月30日前向市场监督管理部门报送一年的年度报告，<span
            class="red">否则将被列入经营异常名录，可以处1万元以下罚款，影响公司经营，并向社会公示。</span></div>
      </div>
      <div class="product-box">
        <div class="product-title">服务办理</div>
        <div class="card-box">
          <div class="card" @click="handleTab(index, item)" :class="[index == selectIndex ? 'card2' : '']"
            v-for="(item, index) in feePackageList" :key="item.id">
            <div class="name-box">
              <div class="name-price-box">
                <!-- <img class="img-code" :src="selectIndex == index ? imageCodeA : imageCode" alt=""> -->
                <div class="product-name">{{ item.productName }}</div>
                <div class="desc">{{ item.description }}</div>
              </div>
              <div class="price">
                <div class="price-x">{{ item.packageCurrentPrice }}元</div>
                <!-- <div class="price-z"><span class="jg">¥{{ item.packageOriginalPrice }}</span></div> -->
              </div>
              <!-- <img class="choose-img" :src="selectIndex == index ? chooseImgA : chooseImg" alt=""> -->
            </div>


          </div>
          <div class="choose-box">
            <choose-pay v-model="payWay" :options="payList"></choose-pay>
          </div>
          <div class="agree">
            <i v-if="isAgree" @click="hanleAgree" class="uc-font uc-checkbox-circle-on uc-blue"></i>
            <i v-else @click="hanleAgree" class="uc-font uc-checkbox-circle"></i>
            <div class="r">
              阅读并同意<a class="uc-blue uc-red" @click="handleXy2(type)">《服务协议》</a>和<a class="uc-blue uc-red"
                @click="handleXy(1)">《隐私政策》</a>
            </div>
          </div>
          <!-- <a v-if="WeChatCS" :href="WeChatCS" @click="handleWx" rel="external nofollow" class="wx-btn"
            :class="{ 'flash': true }">
          </a>
          <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="phone-btn"
            :class="{ 'flash': true }">
          </a> -->

          <Button class="join-btn" :disabled="isDisabled" @click="handlePayOk(name)">确认办理</Button>

        </div>
      </div>
      <div class="wmys-box">
        <img src="../../assets/zx2/fx.png" alt="">
      </div>
      <div class="tl-box">
        <img src="@/assets/zx2/ts.png" alt="">
      </div>

      <div class="lc-box">
        <img src="../../assets/zx2/lc.png" alt="">
      </div>
      <div class="fw-box">
        <img src="../../assets/zx2/fw.png" alt="">
      </div>
      <div class="publicity-box step-box">
        <div class="kf-tel">
          <span class="tel-txt">客服电话：</span>
          <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="uc-blue btn">{{ tel }}</a>
          <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="uc-blue tel-btn">立即咨询</a>
        </div>
        <div class="kf-tel kf-wx" v-if="WeChatCS">
          <span class="tel-txt">客服微信:</span>
          <a :href="WeChatCS" @click="handleWx" rel="external nofollow" class="uc-blue tel-btn">立即咨询</a>
        </div>

        <div class="kf-time">工作时间：<span class="kf-time-txt">周一至周日9:00-23:00</span></div>
        <!-- <div class="line"></div> -->
        <div class="part1">
          <!-- <div class="item">
            <img :src="aboutCpt1" class="uc-icon50" alt="" />
            <a href="javascript:;" @click="alertImg(1)">工商登记信息</a>
          </div> -->
          <!-- <div class="item">
            <img :src="aboutCpt" class="uc-icon50 logo" alt="" />
            <a href="javascript:;" @click="alertImg(2)">域名备案信息</a>
          </div> -->
        </div>

      </div>
      <div class="info"><a href="https://beian.miit.gov.cn">{{ internetContent }} </a> {{ companyName3 }}</div>
      <Button :disabled="isDisabled" class="footer-btn" :class="{ 'flash': true }"
        @click="handlePayOk(name)">确认办理</Button>
      <!-- <div class="footer-btn2">

        <a v-if="WeChatCS" :href="WeChatCS" @click="handleWx" rel="external nofollow" class="wx-btn"
          :class="{ 'flash': true }">
        </a>
        <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="phone-btn" :class="{ 'flash': true }">
        </a>
      </div> -->
    </div>
    <img-popup :imgUrl="imgNum" v-model="showImg" />
    <rules-popup v-if="ruleShow" :showType="showType" :showAgree="showAgree" v-model="ruleShow"
      @btnAlertRule="ruleShow = false" />
    <div class="vant-dialog-box" v-if="isShow">
      <div @click="handleClose" class="van-overlay" style="z-index: 201;"></div>
      <div class="loading">点击屏幕返回页面</div>
      <!-- <div class="van-dialog">
        <div class="header-title">确认支付</div>
        <div @click="handleClose" class='close-btn'>X</div>
        <div class="title-txt">您已申请{{ name }}服务，是否确认付款</div>
        <div class="price-box-1">¥{{ price }}</div>
        <div class="fw">该服务由第三方服务公司{{ companyName2 }}提供</div>
        <div class="agree">
          <i v-if="isAgree" @click="hanleAgree" class="uc-font uc-checkbox-circle-on uc-blue"></i>
          <i v-else @click="hanleAgree" class="uc-font uc-checkbox-circle"></i>
          <div class="r">
            阅读并同意<a class="uc-blue uc-red" @click="handleXy(type)">《服务协议》</a>
            及<a class="uc-blue uc-red" @click="handleXy(1)">《隐私政策》</a>
            且授权办理企业服务。
          </div>
        </div>
        <Button :disabled="isBtn" @click="handlePayOk(name)" class="van-dialog--round-button">确认付款</Button>
      </div> -->
    </div>
    <div class="vant-dialog-box" v-if="tcVang">
      <div class="van-overlay" style="z-index: 201;"></div>
      <div class="van-dialog">
        <div @click="handleClose" class='close-btn'>X</div>
        <div class="title-txt">点击咨询</div>

        <a v-if="WeChatCS" :href="WeChatCS" @click="handleWx" rel="external nofollow" class="wx-btn"
          :class="{ 'flash': true }">
        </a>
        <a :href="'tel:' + tel" @click="handleTel" rel="external nofollow" class="phone-btn" :class="{ 'flash': true }">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { payAddOrder, aliAdapay, getGroundList, burialPoint, wxUrlSchema, payAdapay, payAllList, findH5Config, ConfirmStatus } from "@/api/annual-report"
import ChoosePay from '@/components/choose-pay.vue'
import rulesPopup from '@/components/rules-popup/index.js'
import ImgPopup from '@/components/img-popup.js'
import { Button } from "vant"
import cache from '@/plugins/cache';
import { areaList } from '@vant/area-data';
import { Decrypt, Encrypt } from '@/utils/screate';
export default {
  name: 'Home',
  components: {
    ChoosePay,
    rulesPopup,
    ImgPopup
  },
  data() {
    return {
      feePackageList: [],
      selectId: "",
      isShow: false,
      isAgree: true,
      ruleShow: false,
      showType: 1,
      type: 1,
      showAgree: false,
      payWay: 'alipay',
      payList: [],
      showImg: false,
      imgNum: "",
      selectIndex: 0,
      aboutCpt: require("@/assets/nb/aboutCpt-icon-2.png"),
      aboutCpt1: require("@/assets/nb/aboutCpt-icon-1.png"),
      imageCode: require("@/assets/nb/product-img.png"),
      imageCodeA: require("@/assets/nb/product-img-a.png"),
      companyName1: (window.location.hostname == 'w99u.cn' ? '杭州潍顺企业服务有限公司' : '潍坊睿邦企业服务有限公司'),
      companyName2: (window.location.hostname == 'w99u.cn' ? '杭州潍顺企业服务' : '潍坊睿邦企业服务'),
      bah: (window.location.hostname == 'w99u.cn' ? '浙ICP备2023048713号' : '鲁ICP备2024080747号-1'),
      chooseImgA: require("@/assets/pay/select-a.png"),
      chooseImg: require("@/assets/pay/select.png"),
      isBtn: false,
      WeChatCS: '',
      tel: '400-188-5167',
      sign: '',
      payMethod: 0,
      hasLoaded: false,
      internetContent: '',
      companyName3: '',
      tcVang: false,
      isDisabled: false,
    }
  },
  computed: {
    uuid() {
      return this.$route.query.uuid
    },
    companyName() {
      return this.$route.query.companyName
    },
    legalPerson() {
      return this.$route.query.legalPerson
    },
    tel2() {
      return this.$route.query.tel
    },
    categoryId() {
      return this.$route.query.categoryId || (window.location.hostname == 'w88s.cn' ? 'wls' : 'wls')
    },
  },
  created() {
    this.getConfirmStatus()
    this.getPayList()
    console.log(1233444);
    this.getFindH5Config()
    this.getPackageGroundList()
  },
  mounted() {
    // window.localStorage.setItem('uuid', this.$route.query.uuid ? this.$route.query.uuid : window.localStorage.getItem('uuid'))
    // window.localStorage.setItem('companyName', this.$route.query.companyName ? this.$route.query.companyName : window.localStorage.getItem('companyName'))
    // window.localStorage.setItem('legalPerson', this.$route.query.legalPerson ? this.$route.query.legalPerson : window.localStorage.getItem('legalPerson'))
    // window.localStorage.setItem('tel2', this.$route.query.tel ? this.$route.query.tel : window.localStorage.getItem('tel2'))
    // this.$route.query.categoryId ? window.localStorage.setItem('categoryId', this.$route.query.categoryId ? this.$route.query.categoryId : window.localStorage.getItem('categoryId')) : (window.location.hostname == 'w99u.cn' ? 'wu' : 'wu')

  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     if (!vm.hasLoaded) {
  //       vm.loadData();
  //     }
  //   });
  // },
  destroyed() {
    this.isDisabled = false
    this.isShow = false
  },
  methods: {
    getConfirmStatus() {
      ConfirmStatus({ uuid: this.uuid }).then(res => {
        if (res.success) {
          if (res.data.status) {
            this.$router.push({ path: '/pay-success', query: { productName: res.data.productName, ident: res.data.ident } })
          }
        }
      })
    },
    handleRearson() {
      const currentHour = new Date().getHours();
      if (currentHour >= 18 || currentHour < 9) {
        window.location.href = `tel:${this.tel}`;
      } else {
        this.$router.push({ path: '/complaint' })
      }
    },
    handleWx() {
      this.getBurialPoint(4)
    },
    handleTel() {
      this.getBurialPoint(5)
    },
    getFindH5Config() {
      findH5Config({ uuid: this.uuid, domainName: window.location.host == 'localhost:8080' ? 'w88f.cn' : window.location.host }).then(res => {
        console.log('数据', res);
        this.WeChatCS = res.msgQw
        this.tel = res.msgTel
        this.sign = res.sign
        this.payMethod = res.payMethod
        this.internetContent = res.internetContent
        this.companyName3 = res.companyName
        window.localStorage.setItem('sign', res.sign)
      })
    },
    // loadData() {
    //   // 你的数据加载逻辑
    //   console.log('数据被加载');
    //   //window.location.href = `https://${window.location.hostname}/?uuid=${this.uuid}&companyName=${this.companyName}&legalPerson=${this.legalPerson}&tel=${this.tel2}&categoryId=${this.categoryId}`
    //   this.$router.push({ query: { uuid: this.uuid, companyName: this.companyName, legalPerson: this.legalPerson, tel: this.tel2, categoryId: this.categoryId } });
    //   this.hasLoaded = true;
    // },
    //获取支付方式
    getPayList() {
      payAllList({ domainName: window.location.host == 'localhost:8080' ? 'q.w99h.cn' : window.location.host }).then(res => {
        console.log('123', res.data);
        let arr = []
        if (res.data.length == 1) {
          res.data.forEach(item => {
            if (item.payCode === 'alipay') {
              item.img = require("@/assets/images/pay-2.png")
            } else if (item.payCode === 'wechat') {
              item.img = require("@/assets/images/pay-1.png")
            } else if (item.payCode === 'yhk') {
              item.img = require("@/assets/pay/yhk.png")
            }
            this.payWay = item.payCode
            if (item.enable == 1) {
              arr.push(item)
            }
          }
          )
        } else {
          res.data.forEach(item => {
            if (item.payCode === 'alipay') {
              item.img = require("@/assets/images/pay-2.png")
            } else if (item.payCode === 'wechat') {
              item.img = require("@/assets/images/pay-1.png")
            } else if (item.payCode === 'yhk') {
              item.img = require("@/assets/pay/yhk.png")
            }
            if (item.isFirst == 1) {
              this.payWay = item.payCode
            }
            if (item.enable == 1) {
              arr.push(item)
            }
          }
          )
        }

        this.payList = [...arr]
      })
    },
    getBurialPoint(type) {
      burialPoint({ uid: this.uuid, status: type })
    },
    alertImg(val) {
      // this.showImg = true
      // if (val == 1) {
      //   this.imgNum = this.urlImg1
      // } else {

      //   this.imgNum = this.urlImg2
      // }
    },
    handleTab(index, item) {
      this.selectIndex = index
      this.name = item.productName
      this.selectId = item.id
      // this.tcVang = true
    },
    //协议
    handleXy(type) {
      this.showType = type;
      this.ruleShow = true
    },
    handleXy2() {
      this.getBurialPoint(2)
      if (this.name == '个体户注销') {
        this.type = 3
      } else if (this.name == '纳税登记申报') {
        this.type = 7
      } else {
        this.type = 2
      }
      this.showType = this.type;
      this.ruleShow = true
    },
    //点击同意
    hanleAgree() {
      this.getBurialPoint(2)
      this.isAgree = !this.isAgree
      // if (this.isAgree) {
      //   this.showType = this.type
      //   this.ruleShow = true
      //   this.showAgree = true
      // } else {
      //   this.time = 3
      //   this.showAgree = false
      // }
    },
    //展示弹窗
    handleSummit(item) {
      if (!this.uuid) {
        alert("请通过短链打开页面")
        return false
      }
      this.getBurialPoint(1)
      this.selectId = item.id
      this.name = item.productName
      this.price = item.packageCurrentPrice
      // if (this.selectId == 34) {
      //   this.type = 2
      // } else if (this.name == '公司注销') {
      //   this.type = 3
      // } else {
      //   this.type = 4
      // }
      if (this.name == '个体户注销') {
        this.type = 3
      } else if (this.name == '个体户年度代理记账') {
        this.type = 6
      }
      else {
        this.type = 5
      }
      this.isShow = true
    },
    //关闭弹窗
    handleClose() {
      this.isShow = false
      this.isDisabled = false
      this.isBtn = false
      // this.isAgree = false
      this.tcVang = false
    },
    //确认付款
    handlePayOk() {
      //this.isShow = true
      if (this.payWay == 'yhk') {
        this.handleYhk()
      } else {
        this.handleDoPayment()
      }
    },
    handleYhk() {
      this.$router.push({
        name: 'yhkInfo', query: {
          feePackageId: this.selectId,
          companyName: this.companyName,
          ident: this.uuid,
          legalPerson: this.legalPerson,
          tel: this.tel2,
          uuid: this.uuid,
        },
        params: {
          feePackageId: this.selectId,
        }
      })
      window.localStorage.setItem('feePackageId', this.selectId)
    },
    //获取产品套餐
    getPackageGroundList() {
      getGroundList({ belongTo: 'MSG', categoryId: this.categoryId, domain: window.location.host == 'localhost:8080' ? 'w88f.cn' : window.location.host }).then(res => {
        console.log(1233, res);
        if (res.success) {
          this.feePackageList = res.data
          this.selectId = res.data[0].id
        }
      })
    },
    //支付接口
    handleDoPayment() {
      this.getBurialPoint(3)
      // if (!this.isAgree) {
      //   alert('请勾选同意《服务协议》及《隐私政策》')
      //   return
      // }
      this.isBtn = true
      this.isDisabled = true
      const params = {
        companyName: this.companyName,
        ident: this.uuid,
        legalPerson: this.legalPerson,
        feePackageId: this.selectId,
        tel: this.tel2,
        domainName: window.location.host,
      }
      if (this.payWay === 'alipay') {
        payAdapay(params).then(response => {
          try {
            if (!response.success) {
              alert(response.message)
              this.isShow = false
              this.isAgree = false
              this.handleScroll()
              return false
            }
            if (response.data) {
              // const newDiv = document.createElement('div');
              // newDiv.innerHTML = response.data
              // document.body.append(newDiv)
              // document.forms['alipaysubmit'].submit();
              window.location.href = response.data
            }
            this.isBtn = false
            this.isDisabled = false
          } catch (error) {
            this.isBtn = false
            this.isDisabled = false
          }
        }).catch(error => {
          this.isBtn = false
          this.isDisabled = false
        })
      } else if (this.payWay === 'wechat') {
        const data = {
          ...params,
        }
        const payObj = this.payMethod == 1 ? wxUrlSchema : payAddOrder
        payObj({ ...data }).then(response => {
          try {
            if (!response.success) {
              alert(response.message)
              this.isShow = false
              this.isAgree = false
              this.handleScroll()
              return false
            }
            if (response.data) {
              if (this.payMethod == 2) {
                let wxUrl = `${response.data}${encodeURIComponent('&redirect_url=')}${encodeURIComponent(encodeURIComponent(encodeURIComponent('https://' + window.location.host + '/')))}`
                window.location.href = wxUrl
              } else {
                window.location.href = response.data
              }
            }
            this.isBtn = false
            this.isDisabled = false
          } catch (error) {
            this.isBtn = false
            this.isDisabled = false
            this.isShow = false
          }
        }).catch(error => {
          this.isBtn = false
          this.isDisabled = false
          this.isShow = false
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content-box {
  padding-bottom: 20px;
  width: 100%;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 70px;
  background: linear-gradient(180deg, #4795F5 0%, #FFFFFF 18%, #FFFFFF 100%);
  background-repeat: no-repeat;
  background-size: 100%;



  .content {
    padding-top: 13px;

    .rearson {
      width: 95px;
      height: 47px;
      background-color: #FF2525;
      background-size: 100%;
      background-repeat: no-repeat;
      position: absolute;
      top: 22%;
      left: 0px;
      z-index: 9999;
      text-align: center;
      border-radius: 0 20px 20px 0;
      padding-top: 5px;

      .txt {
        color: #ffffff;
        font-size: 16px;
      }
    }

    .header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 20px;

      .sign-box {
        display: flex;
        align-items: center;

        .logo {
          width: 26px;
          height: 19px;
        }

        .header-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;

        }
      }

      .tel-box {
        display: flex;
        align-items: center;

        .tel-icon {
          width: 20px;
          height: 20px;
        }

        .uc-blue {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          margin-left: 4px;
        }
      }



    }

    .info-box {
      margin: 0 auto;
      padding: 13px 0px;
      padding-left: 16px;
      margin-top: 10px;
      width: 353px;

      background: rgba(255, 255, 255, 0.49);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      backdrop-filter: blur(2px);


      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        position: absolute;
        top: 56px;
        right: 26px;
      }

      .company-box {
        align-items: center;
        padding-top: 0px;
        min-height: 52px;

        .tis {
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-weight: 800;
          font-size: 20px;
          color: #FF2727;
          margin-top: 3px;
        }

        .company {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #821B1B;
          min-height: 25px;
        }

        .legalPerson-box {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          margin-top: 10px;

          .legalPerson {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            margin-left: 4px
          }
        }
      }

      .lxfs-box {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .tel-btn {
          height: 34px;
          background-color: #FF3C3C;
          background-size: 100%;
          background-repeat: no-repeat;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 34px;
          text-align: center;
          border-radius: 17px;
          padding: 0 15px;
        }

        .wx-btn {
          height: 34px;
          background-color: #3480E7;
          background-size: 100%;
          background-repeat: no-repeat;
          margin-left: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 34px;
          text-align: center;
          border-radius: 17px;
          padding: 0 15px;
        }
      }

      .tips2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #333333;
        margin-top: 6px;

        .red {
          color: #FF3131;
        }
      }

      .kf-wx {
        .tel-btn {
          margin-left: 0;
        }
      }
    }

    .yc-img {
      margin: 0 auto;
      padding-left: 10px;
      margin-top: 19px;

      img {
        width: 315px;
        height: 109px;
        display: block;
      }
    }

    .fk-list-box {
      margin-top: 20px;
      margin-bottom: 5px;

      .title {
        font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
        font-weight: 900;
        font-size: 22px;
        color: #EF4400;
        text-align: center;
        font-style: normal;
        text-shadow: 0.5px 0.5px 0 rgba(239, 68, 0, 1);
      }

      .fk-title {
        width: 355px;
        height: 45px;
        background: #CFDCFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #2653D1;
        line-height: 45px;
        text-align: center;
        margin: 0 auto;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
        border-radius: 8px 8px 0 0px;
        margin-top: 15px;
      }

      .fk-list {
        width: 355px;
        background: linear-gradient(79deg, #FFFFFF 0%, #FFFBF7 100%);
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
        border-radius: 0px 0px 8px 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #570A00;
        line-height: 24px;
        margin: 0 auto;
        padding: 0 12px;
        padding-top: 10px;
        text-align: justify;
        padding-bottom: 14px;

        .red {
          color: #FF3318;
        }
      }
    }


    .product-box {
      width: 361px;
      margin: 0 auto;
      background: linear-gradient(to bottom, #f5f9ff, #FFFFFF);
      padding-bottom: 10px;
      box-shadow: inset 0px -0.5px 1px rgba(162, 168, 179, 0.5);
      border-radius: 0px 0px 10px 10px;
      padding-top: 10px;
      margin-top: 10px;

      .product-title {
        font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
        font-weight: 600;
        font-size: 24px;
        color: #103A68;
        text-align: center;
      }

      .card-box {
        padding-top: 10px;

        .card {
          width: 338px;
          height: 6%;
          margin: 0 auto;
          background-image: url("../../assets/zx2/product.png");
          background-repeat: no-repeat;
          background-size: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 10px;
          padding-right: 10px;
          margin-bottom: 6px;
          position: relative;


          .name-box {
            display: flex;
            align-items: center;
            height: 66px;
            width: 100%;
            justify-content: space-between;
            padding-left: 14px;


            .name-price-box {
              .img-code {
                width: 23px;
                height: 25px;
                display: block;
                margin-right: 8px;
              }

              .desc {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #471C00;
                margin-top: 2px;
              }
            }

            .product-name {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #333333;
            }
          }

          .price {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 800;
            font-size: 18px;
            color: #E25F59;
            display: flex;
            align-items: center;
            margin-right: 40px;

            .price-x {
              font-family: SourceHanSansCN, SourceHanSansCN;
              font-weight: 800;
              font-size: 18px;
              color: #E25F59;
            }
          }

          .price-z {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #CAD3DD;
            text-align: left;
            font-style: normal;
            text-decoration-line: line-through;

            .jg {
              text-decoration: line-through;
            }
          }

          .choose-img {
            width: 15px;
            height: 15px;
            margin-left: 5px;
          }
        }

        .card2 {
          width: 338px;
          height: 66px;
          background-image: url("../../assets/zx2/product-a.png");
          background-repeat: no-repeat;
          background-size: 100%;



        }

        .wx-btn {
          display: block;
          width: 318px;
          height: 48px;
          background-image: url("../../assets/zx/wx-btn.png");
          background-repeat: no-repeat;
          background-size: 100%;
          margin: 0 auto;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 8px;


          .wx-img {
            width: 25px;
            height: 20px;
            margin-right: 4px;
          }
        }

        .phone-btn {
          display: block;
          width: 318px;
          height: 48px;
          background-image: url("../../assets/zx/tel-btn.png");
          background-repeat: no-repeat;
          background-size: 100%;
          margin: 0 auto;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 12px;


          .tel-img {
            width: 23px;
            height: 21px;
            margin-right: 4px;
          }
        }

        .join-btn {
          width: 355px;
          height: 52px;
          display: block;
          background: linear-gradient(109deg, #FFB737 0%, #FF9565 100%);
          border-radius: 26px;
          margin: 0 auto;
          margin-top: 5px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #FFFFFF;
          text-align: center;
          line-height: 52px;
        }

        .choose-box {
          padding: 0 20px;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .tips {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 17px;
          padding: 0 10px;
          margin-top: 10px;
          text-align: justify;

          .tips1 {
            color: #0590F3;
          }

          .tips2 {
            color: #FA3B3B;
          }
        }

        .ys-box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 5px;
          padding: 0 20px;

          img {
            width: 158px;
            height: 158px;
            display: block;
          }
        }
      }

    }

    .lxwm {
      margin-top: 10px;
    }

    .ft-box {
      margin-bottom: 15px;
    }

    .fk-box {
      margin-top: 10px;
      margin-bottom: 15px;

      img {
        width: 335px;
        height: 80px;
        margin: 0 auto;
        display: block;
      }
    }

    .al-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #B40000;
      line-height: 16px;
      text-align: center;
      margin-bottom: 16px;
    }

    .tz-box {
      margin-top: 20px;

      img {
        width: 359px;
        height: 161px;
        display: block;
        margin: 0 auto;
      }
    }

    .yh-box {
      img {
        width: 356px;
        height: 122px;
        margin: 0 auto;
        display: block;
      }
    }

    .tl-box {
      margin-top: 6px;

      img {
        width: 361px;
        height: 135px;
        margin: 0 auto;
        display: block;
      }
    }


    .wmys-box {

      margin-top: 6px;

      img {
        width: 363px;
        height: 424px;
        display: block;
        margin: 0 auto;
      }
    }

    .lc-box {
      margin-top: 6px;

      img {
        width: 363px;
        height: 148px;
        display: block;
        margin: 0 auto;
      }
    }

    .fw-box {
      margin-top: 6px;


      img {
        width: 363px;
        height: 218px;
        display: block;
        margin: 0 auto;
      }
    }

    .publicity-box {
      padding-left: 15px;
      padding-top: 46px;
      width: 361px;
      height: 168px;
      background-image: url("../../assets/zx2/lxwm.png");
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0 auto;

      .user-title {
        color: #1166F2;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        margin-bottom: 10px;
      }

      .kf-tel {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .tel-txt {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }

        a {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #5490FF;
        }

        .tel-btn {
          display: block;
          height: 24px;
          background-color: #0082E9;
          border-radius: 12px;
          background-repeat: no-repeat;
          background-size: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          margin-left: 10px;
          text-align: center;
          line-height: 24px;
          padding: 0 12px;
        }

        .wx-btn {
          padding: 0 12px;
          height: 22px;
        }

      }

      .kf-time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-top: 7px;

        .kf-time-txt {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
      }

      .line {
        width: 355px;
        height: 1px;
        background: #CDEAFF;
        margin: 14px auto;
      }
    }

    .info {
      font-family: PingFang SC, PingFang SC;
      font-weight: 300;
      font-size: 14px;
      color: #717171;
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: center;

      a {
        font-family: PingFang SC, PingFang SC;
        font-weight: 300;
        font-size: 14px;
        color: #717171;
      }
    }

  }

  .footer-btn {
    width: 100%;
    height: 48px;
    background: #FF953C;
    border-radius: 4px;
    position: fixed;
    left: 0;
    bottom: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 48px;
    text-align: center;
  }

  .footer-btn2 {
    width: 100%;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;

    .wx-btn {
      display: block;
      width: 100%;
      height: 60px;
      background-image: url("../../assets/zx/foot-wx-btn.png");
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0 auto;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;


      .wx-img {
        width: 25px;
        height: 20px;
        margin-right: 4px;
      }
    }

    .phone-btn {
      display: block;
      width: 100%;
      height: 60px;
      background-image: url("../../assets/zx/foot-tel-btn.png");
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0 auto;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;

      .tel-img {
        width: 23px;
        height: 21px;
        margin-right: 4px;
      }
    }
  }

  .vant-dialog-box {
    .loading {
      position: fixed;
      top: 50%;
      left: 50%;
      color: #ffffff;
      transform: translate(-50%, -50%);
      z-index: 9999999;
      border: 1px solid #ffffff;
      padding: 10px;
      width: 68%;
      text-align: center;
    }

    .van-overlay {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .7);
      z-index: 2001;

      .fw {
        text-align: center;
        margin-top: 10px;
      }
    }

    .header-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      text-align: center;
      padding-top: 20px;
    }

    .van-dialog {
      border-radius: 2px;
      width: 355px;
      background: #FFFFFF;
      top: 48%;
      position: fixed;
      left: 50%;
      overflow: hidden;
      font-size: 16px;
      background-color: #fff;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transition: .3s;
      transition: .3s;
      -webkit-transition-property: opacity, -webkit-transform;
      transition-property: opacity, -webkit-transform;
      transition-property: transform, opacity;
      transition-property: transform, opacity, -webkit-transform;
      z-index: 9999;
      height: 201px;
      border-radius: 8px;
    }

    .van-dialog--round-button {
      width: 335px;
      height: 45px;
      background: linear-gradient(230deg, #8FB9ED 0%, #4497EB 100%);
      border-radius: 10px;
      opacity: 1;
      border: none;
      border-radius: 2px;
      color: #ffffff;
      text-align: center;
      line-height: 45px;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      font-family: MiSans-Demibold, MiSans;
      font-weight: 600;
      color: #FFFFFF;
      border-radius: 4px;
      display: block;
    }

    .van-dialog--round-button .van-dialog__message {
      display: flex;
      flex-wrap: wrap;
      /* align-items: center; */
      justify-content: center;
    }

    .close-btn {
      color: #BCC0C8;
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 14px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      border: 1px solid #BCC0C8;
      text-align: center;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .wx-btn {
      display: block;
      width: 318px;
      height: 48px;
      background-image: url("../../assets/zx/wx-btn.png");
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0 auto;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;

      .wx-img {
        width: 25px;
        height: 20px;
        margin-right: 4px;
      }
    }

    .phone-btn {
      display: block;
      width: 318px;
      height: 48px;
      background-image: url("../../assets/zx/tel-btn.png");
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0 auto;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;

      .tel-img {
        width: 23px;
        height: 21px;
        margin-right: 4px;
      }
    }

    .fw {
      text-align: center;
      margin-top: 10px;
    }

    .van-dialog__cancel {
      color: #BCC0C8;
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      cursor: pointer;
    }

    .title-txt {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-top: 20px;
      text-align: center;
    }

    .price-box-1 {
      font-size: 24px;
      font-family: MiSans-Medium, MiSans;
      font-weight: 600;
      color: #F5461D;
      text-align: center;
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }


  }

  .part1 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 12px;

    .item {
      display: flex;
      align-items: center;

      .uc-icon50 {
        width: 14px;
        height: 14px;
        margin-right: 2px;
      }

      a {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }
    }

    .item:last-child {
      //margin-left: 21px;
    }
  }
}
</style>
<style lang="scss" scoped>
.flash {
  animation: scale-animation 1s infinite;
}

@keyframes flash-animation {

  0%,
  100% {
    background-color: red;
  }

  50% {
    background-color: yellow;
  }
}

@keyframes scale-animation {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }
}
</style>